import api from './api';

const syncTemplatesService = {
    // Templates
    listTemplates: async () => {
        const response = await api.get('/admin/synctemplates');
        return response.data;
    },

    getTemplate: async (id) => {
        const response = await api.get(`/admin/synctemplates/${id}`);
        return response.data;
    },

    createTemplate: async (data) => {
        const response = await api.post('/admin/synctemplates', data);
        return response.data;
    },

    updateTemplate: async (id, data) => {
        const response = await api.put(`/admin/synctemplates/${id}`, data);
        return response.data;
    },

    deleteTemplate: async (id) => {
        const response = await api.delete(`/admin/synctemplates/${id}`);
        return response.data;
    },

    // Scopes
    listScopes: async () => {
        const response = await api.get('/admin/synctemplates/scopes');
        return response.data;
    },

    createScope: async (data) => {
        const response = await api.post('/admin/synctemplates/scopes', data);
        return response.data;
    },

    updateScope: async (scopeId, data) => {
        const response = await api.put(`/admin/synctemplates/scopes/${scopeId}`, data);
        return response.data;
    },

    deleteScope: async (scopeId) => {
        const response = await api.delete(`/admin/synctemplates/scopes/${scopeId}`);
        return response.data;
    },

    // Tasks
    listTasks: async (templateId) => {
        const response = await api.get(`/admin/synctemplates/${templateId}/tasks`);
        return response.data;
    },

    getTask: async (templateId, taskId) => {
        const response = await api.get(`/admin/synctemplates/${templateId}/tasks/${taskId}`);
        return response.data;
    },

    createTask: async (templateId, data) => {
        const response = await api.post(`/admin/synctemplates/${templateId}/tasks`, data);
        return response.data;
    },

    updateTask: async (templateId, taskId, data) => {
        const response = await api.put(`/admin/synctemplates/${templateId}/tasks/${taskId}`, data);
        return response.data;
    },

    deleteTask: async (templateId, taskId) => {
        const response = await api.delete(`/admin/synctemplates/${templateId}/tasks/${taskId}`);
        return response.data;
    },

    // Instructions
    listInstructions: async (templateId, taskId) => {
        const response = await api.get(`/admin/synctemplates/${templateId}/tasks/${taskId}/instructions`);
        return response.data;
    },

    createInstruction: async (templateId, taskId, data) => {
        const response = await api.post(`/admin/synctemplates/${templateId}/tasks/${taskId}/instructions`, data);
        return response.data;
    },

    updateInstruction: async (templateId, taskId, instructionId, data) => {
        const response = await api.put(`/admin/synctemplates/${templateId}/tasks/${taskId}/instructions/${instructionId}`, data);
        return response.data;
    },

    deleteInstruction: async (templateId, taskId, instructionId) => {
        const response = await api.delete(`/admin/synctemplates/${templateId}/tasks/${taskId}/instructions/${instructionId}`);
        return response.data;
    },

    setDefaultInstruction: async (templateId, taskId, instructionId) => {
        const response = await api.post(`/admin/synctemplates/${templateId}/tasks/${taskId}/instructions/${instructionId}/setdefault`);
        return response.data;
    },

    // Processes
    listProcesses: async (templateId, taskId) => {
        const response = await api.get(`/admin/synctemplates/${templateId}/tasks/${taskId}/processes`);
        return response.data;
    },

    createProcess: async (templateId, taskId, data) => {
        const response = await api.post(`/admin/synctemplates/${templateId}/tasks/${taskId}/processes`, data);
        return response.data;
    },

    updateProcess: async (templateId, taskId, processId, data) => {
        const response = await api.put(`/admin/synctemplates/${templateId}/tasks/${taskId}/processes/${processId}`, data);
        return response.data;
    },

    deleteProcess: async (templateId, taskId, processId) => {
        const response = await api.delete(`/admin/synctemplates/${templateId}/tasks/${taskId}/processes/${processId}`);
        return response.data;
    },

    setDefaultProcess: async (templateId, taskId, processId) => {
        const response = await api.post(`/admin/synctemplates/${templateId}/tasks/${taskId}/processes/${processId}/setdefault`);
        return response.data;
    },

    // Processing Steps
    listProcessingSteps: async (templateId) => {
        const response = await api.get(`/admin/synctemplates/${templateId}/steps`);
        return response.data;
    },

    createProcessingStep: async (templateId, data) => {
        const response = await api.post(`/admin/synctemplates/${templateId}/steps`, data);
        return response.data;
    },

    updateProcessingStep: async (templateId, stepId, data) => {
        const response = await api.put(`/admin/synctemplates/${templateId}/steps/${stepId}`, data);
        return response.data;
    },

    deleteProcessingStep: async (templateId, stepId) => {
        const response = await api.delete(`/admin/synctemplates/${templateId}/steps/${stepId}`);
        return response.data;
    },
};

export default syncTemplatesService;
